<template>
  <el-dialog :visible="visible" @close="handleClose" :close-on-click-modal="false">
    <div class="interaction-head">操作确认</div>
    <div class="history-page">
      <div class="page-h">确定您已发现火情</div>
    </div>
    <div class="bt-box">
      <div class="bt2" @click="handleClose">取消</div>
      <div class="bt" @click="submit">确认</div>
    </div>
  </el-dialog>
</template>

<script>
import {discoverFire} from '@/api/kecang'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    eventId: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('handle-close')
    },
    async submit() {
      const res = await discoverFire(this.type,this.eventId)
      if ('A00000' === res.code) {
        this.$message.success('提交成功')
        this.handleClose()
      } else {
        this.$message.error(res.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  margin: 0 !important;
  background: url("~@/assets/images/index/xian.png") no-repeat #262D40;
  background-size: 100% 100%;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  width: 400px;
  height: 230px;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    color: #fff;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
  }

  .el-dialog__headerbtn {
    top: 22px;
  }
}

.page-h {
  font-size: 18px;
  height: 50px;
  margin-bottom: 24px;
  margin-top: 24px;
}

.bt-box {
  display: flex;
  align-items: center;
  justify-content: center;

  .bt2 {
    width: 168px;
    height: 44px;
    border-radius: 8px;
  }

  .bt {
    width: 168px;
    height: 44px;
    border-radius: 8px;
    margin: 0;
    margin-left: 16px;
  }
}

.interaction-head {
  font-size: 16px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/components/FireDiscoverDialog.vue